import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ABMTableComponent } from './abmtable.component';
import { MatPaginatorIntlEs } from '../interfaces/paginator-translation';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { ComponentesService } from '../componentes.service';
import { NumformPipe } from '@tres-erres/ngx-utils';

@NgModule({
	declarations: [
		ABMTableComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatTableModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatMenuModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatBottomSheetModule,
		MatInputModule,
		MatButtonModule,
		MatSnackBarModule,
		MatIconModule
	],
	providers: [
		{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlEs },
		ComponentesService,
		NumformPipe
	],
	exports: [
		ABMTableComponent
	]
})
export class ABMTableModule { }
